/**
 * Proximity Disable Test
 * 
 * This utility helps disable all proximity-related systems to isolate
 * the cause of the lag when players get close to each other.
 */

// Global flag to disable all proximity systems
let proximitySystemsDisabled = false;

export const disableAllProximitySystems = () => {
  proximitySystemsDisabled = true;
  console.log('🚫 All proximity systems disabled for testing');
  
  // Disable nameplate systems
  if (typeof window !== 'undefined') {
    (window as any).NameplateManagerGlobalLoopActive = true;
  }
  
  // Disable proximity calculations
  if (typeof window !== 'undefined') {
    (window as any).disableProximityCalculations = true;
  }
  
  // Disable WebRTC proximity updates
  if (typeof window !== 'undefined') {
    (window as any).disableWebRTCProximity = true;
  }
  
  // Disable follow button animations
  if (typeof window !== 'undefined') {
    (window as any).disableFollowAnimations = true;
  }
  
  // Disable area detection
  if (typeof window !== 'undefined') {
    (window as any).disableAreaDetection = true;
  }
};

export const enableAllProximitySystems = () => {
  proximitySystemsDisabled = false;
  console.log('✅ All proximity systems enabled');
  
  // Re-enable all systems
  if (typeof window !== 'undefined') {
    (window as any).NameplateManagerGlobalLoopActive = false;
    (window as any).disableProximityCalculations = false;
    (window as any).disableWebRTCProximity = false;
    (window as any).disableFollowAnimations = false;
    (window as any).disableAreaDetection = false;
  }
};

export const enableCamerasOnly = () => {
  console.log('🎥 Enabling cameras only - nameplates disabled');
  
  if (typeof window !== 'undefined') {
    (window as any).NameplateManagerGlobalLoopActive = true; // Keep nameplates disabled
    (window as any).disableProximityCalculations = false; // Enable proximity calculations
    (window as any).disableWebRTCProximity = false; // Enable WebRTC proximity
    (window as any).disableFollowAnimations = true; // Keep follow animations disabled
    (window as any).disableAreaDetection = false; // Enable area detection
  }
};

export const disableCameraRepositioning = () => {
  console.log('🚫 Disabling camera repositioning/snapping');
  
  if (typeof window !== 'undefined') {
    (window as any).disableCameraRepositioning = true; // Disable camera repositioning
  }
};

export const enableCameraRepositioning = () => {
  console.log('✅ Enabling camera repositioning/snapping');
  
  if (typeof window !== 'undefined') {
    (window as any).disableCameraRepositioning = false; // Enable camera repositioning
  }
};

export const isProximityDisabled = () => proximitySystemsDisabled;

// Add global functions for easy testing
if (typeof window !== 'undefined') {
  (window as any).disableProximity = disableAllProximitySystems;
  (window as any).enableProximity = enableAllProximitySystems;
  (window as any).enableCamerasOnly = enableCamerasOnly;
  (window as any).disableCameraRepositioning = disableCameraRepositioning;
  (window as any).enableCameraRepositioning = enableCameraRepositioning;
  (window as any).isProximityDisabled = isProximityDisabled;
}
